import PropTypes from "prop-types";

export default function ModuleChartPieTool({
  data,
  headTemplate,
  bodyTemplate,
}) {
  return (
    <div>
      {headTemplate}

      <table>
        <tbody>
          {data.map((item, index) => bodyTemplate({ data: item, index }))}
        </tbody>
      </table>
    </div>
  );
}

ModuleChartPieTool.propTypes = {
  bodyTemplate: PropTypes.func.isRequired,
  data: PropTypes.array,
  headTemplate: PropTypes.node,
};
